import { cx } from 'cvb';
import PropTypes from 'prop-types';
import { zIndex } from '../../../../../config/styles';
import { noop } from '../../../../../utils/noop';
import { useImageGalleryControlButtons } from '../hooks/useImageGalleryControlButtons';
import { ImageGalleryControlButtonsStyles } from './style';

const ImageGalleryControlButtons = ({ onPreviousHeadLine, onNextHeadline, onMoveOver, variant, isConnect }) => {
  const hookData = useImageGalleryControlButtons({
    onPreviousHeadLine,
    onNextHeadline,
    onMoveOver,
    variant,
    isConnect,
  });

  if (!hookData.shouldRender) {
    return null;
  }

  const { leftButtonConfig, rightButtonConfig } = hookData;

  return (
    <div className="image-gallery-control-buttons">
      <button
        id={leftButtonConfig.id}
        type="button"
        className={cx(
          'image-gallery-control-buttons__button',
          'image-gallery-control-buttons__button--left',
          `image-gallery-control-buttons__button--${variant}`,
          {
            'image-gallery-control-buttons__button--connect': isConnect,
          }
        )}
        onClick={leftButtonConfig.onClick}
        onMouseMove={leftButtonConfig.onMouseMove}
        aria-label={leftButtonConfig['aria-label']}
      >
        <i className="icon csicon-arrow_left" />
      </button>

      <button
        id={rightButtonConfig.id}
        type="button"
        className={cx(
          'image-gallery-control-buttons__button',
          'image-gallery-control-buttons__button--right',
          `image-gallery-control-buttons__button--${variant}`,
          {
            'image-gallery-control-buttons__button--connect': isConnect,
          }
        )}
        onClick={rightButtonConfig.onClick}
        onMouseMove={rightButtonConfig.onMouseMove}
        aria-label={rightButtonConfig['aria-label']}
        style={{
          position: 'absolute',
          top: '50%',
          right: '16px',
          transform: 'translateY(-50%)',
          width: '32px',
          height: '32px',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          border: '2px solid rgba(255, 255, 255, 0.8)',
          borderRadius: '50%',
          zIndex: zIndex.imageGallery.button,
          pointerEvents: 'auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
        }}
      >
        <i className="icon i-gallery csicon-arrow_right" />
      </button>
      <style jsx>{ImageGalleryControlButtonsStyles}</style>
    </div>
  );
};

ImageGalleryControlButtons.defaultProps = {
  onMoveOver: noop,
  variant: 'transparent',
  isConnect: false,
};

ImageGalleryControlButtons.propTypes = {
  onPreviousHeadLine: PropTypes.func.isRequired,
  onNextHeadline: PropTypes.func.isRequired,
  onMoveOver: PropTypes.func,
  variant: PropTypes.oneOf(['opaque', 'transparent', 'smallAndTransparent']),
  isConnect: PropTypes.bool,
};

export { ImageGalleryControlButtons };
export default ImageGalleryControlButtons;
